module.exports = __webpack_public_path__ + "static/img/2018-06-09 16.14.29.a31d023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2018-06-09 16.14.29.jpg
// module id = dR/U
// module chunks = 4